import { SaveExcessCashParams } from './api/useManageExcessCashMutation';
import {
  AllocationStrategyType,
  FormValues,
  includesDebtManagementEarmark,
  isDebtManagementOnlyEarmark,
} from './ManageExcessCashModal.meta';

export const toSaveExcessCashParams = (
  values: FormValues,
  hasDebtManagementGoal: boolean,
): SaveExcessCashParams => {
  const {
    ExcessCashGoalEarmark: goalEarmarks,
    LoanPayoffStrategy: loanPayoffStrategy,
    ExcessCashFlowStrategy: { type, data: strategyData },
  } = values;
  const isDebtOnly = isDebtManagementOnlyEarmark(goalEarmarks);
  // `??` keeps MarketAssumptions (0). Debt-only with no source must not omit the
  // enum; the backend would deserialize missing as MarketAssumptions.
  const allocationType = isDebtOnly
    ? (type ?? AllocationStrategyType.AdviserSettings)
    : (type as AllocationStrategyType);
  const shouldPersistGoalEarmark =
    isDebtOnly || allocationType !== AllocationStrategyType.ExistingAccount;
  const shouldPersistLoanPayoffStrategy =
    shouldPersistGoalEarmark
    && goalEarmarks?.some(earmark =>
      includesDebtManagementEarmark(earmark, hasDebtManagementGoal),
    );

  return {
    ExcessCashGoalEarmark: shouldPersistGoalEarmark ? goalEarmarks : null,
    LoanPayoffStrategy: shouldPersistLoanPayoffStrategy ? loanPayoffStrategy : null,
    ExcessCashAllocationType: allocationType,
    ExcessCashAllocationDetails: {
      modelPortfolios:
        allocationType === AllocationStrategyType.PortfolioGroup
          ? strategyData?.modelPortfolios ?? null
          : null,
      marketAssumptions:
        allocationType === AllocationStrategyType.MarketAssumptions
          ? strategyData?.marketAssumptions?.map(item => ({
              ...item,
              y: Number(((Number(item.y) || 0) / 100).toFixed(4)),
            })) ?? null
          : null,
      hypotheticalReturnPercent:
        allocationType === AllocationStrategyType.HypotheticalReturn
          ? strategyData?.hypotheticalReturnPercent ?? null
          : null,
      existingAccountId:
        allocationType === AllocationStrategyType.ExistingAccount
          ? strategyData?.existingAccountId ?? null
          : null,
    },
  };
};
